import React from "react";
import { useGlobalContext } from "./context/globalContext";

const Amenities = ({ project }) => {
  const { handleShowModal } = useGlobalContext();
  const mediaButtonStyle = {
    background: "transparent",
    border: 0,
    display: "block",
    padding: 0,
    textAlign: "left",
    width: "100%",
  };
  return (
    <section className="section shadow-sm lazyloaded" id="Amenities">
      <span className="section-link"></span>{" "}
      <div className="row">
        <div className="col-md-8">
          <h2 className="head text-capitalize">{project} - Amenities</h2>
        </div>
        <div className="col-md-4">
          <button
            className="btn btn-info micro-form-btn enqModal effetGradient effectScale float-lg-right mx-sm-auto  d-none d-lg-block"
            onClick={handleShowModal}
          >
            Download Amenities
          </button>
        </div>
      </div>
      <div className="owl-carousel-img owl-carousel owl-theme gallery-img">
        <div className="at-property-item">
          <button
            type="button"
            data-fancybox="gallery-0"
            className="at-property-img"
            onClick={handleShowModal}
            style={mediaButtonStyle}
          >
            {" "}
            <img
              data-src="../images/lntevaraheightsgym.webp"
              loading="lazy"
              className="gallery-thumb ls-is-cached lazyloaded"
              src="images/lntevaraheightsgym.webp"
              alt={`${project} gym amenity`}
            />
            <div className="at-property-overlayer"></div>
            <span className="btn btn-default at-property-btn">
              View Amenities
            </span>
          </button>
        </div>
        <div className="at-property-item">
          <button
            type="button"
            data-fancybox="gallery-0"
            className="at-property-img"
            onClick={handleShowModal}
            style={mediaButtonStyle}
          >
            {" "}
            <img
              data-src="../images/lntevaraheightsindoorgameroom.webp"
              loading="lazy"
              className="gallery-thumb ls-is-cached lazyloaded"
              src="images/lntevaraheightsindoorgameroom.webp"
              alt={`${project} indoor game room amenity`}
            />
            <div className="at-property-overlayer"></div>
            <span className="btn btn-default at-property-btn">
              View Amenities
            </span>
          </button>
        </div>
        <div className="at-property-item">
          <button
            type="button"
            data-fancybox="gallery-0"
            className="at-property-img"
            onClick={handleShowModal}
            style={mediaButtonStyle}
          >
            {" "}
            <img
              data-src="../images/lntevaraheightskidsplayarea.webp"
              loading="lazy"
              className="gallery-thumb ls-is-cached lazyloaded"
              src="images/lntevaraheightskidsplayarea.webp"
              alt={`${project} kids play area amenity`}
            />
            <div className="at-property-overlayer"></div>
            <span className="btn btn-default at-property-btn">
              View Amenities
            </span>
          </button>
        </div>
      </div>
      <div className="col-12">
        <button
          className="chat-btn btn btn-info micro-form-btn enqModal effetGradient effectScale float-lg-right mx-sm-auto d-lg-none"
          data-form="lg"
          data-title="Download Gallery"
          data-btn="Send Now"
          data-enquiry="Download Gallery"
          data-redirect="floorplan"
          data-toggle="modal"
          data-target="#enqModal"
          onClick={handleShowModal}
        >
          Download Amenities
        </button>
      </div>
    </section>
  );
};

export default Amenities;
